module.exports = __webpack_public_path__ + "c967960aa47239b2f70e59cb665d458b.pdf";